module.exports = __webpack_public_path__ + "img/lacy-foundries.7d589102.jpg";